import { IState } from '../types';
import { IContentLibSearchFilter } from './types';

export class ContentLibSelectors {

  public static getSearchFilter(state: IState): IContentLibSearchFilter {
    return {...state.contentLib.searchFilter};
  }

}
